import {
  PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_BEGIN,
  PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_SUCCESS,
  PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_FAILURE,
  PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function apicallGetTbalesData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_BEGIN,
    });
    const { version, projectId, dbUuid } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xanoNew/xano-getapi/${dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_SUCCESS,
            data: res.data.getdata,
          });
          resolve(res);
          console.log('getdataapi', res);
        },

        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('getdataapierror', err);
        },
      );
    });

    return promise;
  };
}

export function dismissApicallGetTbalesDataError() {
  return {
    type: PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_BEGIN:
      return {
        ...state,
        apicallGetTbalesDataPending: true,
        apicallGetTbalesDataError: null,
      };

    case PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_SUCCESS:
      return {
        ...state,
        apicallGetTbalesDataPending: false,
        apicallGetTbalesDataError: null,
        apigetTableData: action.data,
      };

    case PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_FAILURE:
      return {
        ...state,
        apicallGetTbalesDataPending: false,
        apicallGetTbalesDataError: action.data.error,
      };

    case PROJECT_ON_BOARD_APICALL_GET_TBALES_DATA_DISMISS_ERROR:
      return {
        ...state,
        apicallGetTbalesDataError: null,
      };

    default:
      return state;
  }
}
